import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header/Header';
import Banner from '../Header/Banner';
import SubHeader from '../Header/SubHeader';

class Flex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: props.height,
    };
  }

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    this.setState({ height: window.innerHeight - 90 });
  };

  getFullHeightStyles = () => {
    const { height } = this.state;
    const styles = {};
    styles.height = `${height}px`;
    return styles;
  };

  render() {
    const { children, headerTitle, showSubHeader } = this.props;
    return (
      <>
        <Header {...this.props} title={headerTitle} />
        <Banner />
        {showSubHeader && <SubHeader {...this.props} title={headerTitle} />}
        <div style={this.getFullHeightStyles()}>
          <div className=" align-self-center height-box">
            <div className="d-flex align-items-stretch flex-column h-100">{children}</div>
          </div>
        </div>
      </>
    );
  }
}
export default Flex;

Flex.propTypes = {
  headerTitle: PropTypes.string,
  children: PropTypes.shape().isRequired,
  height: PropTypes.number,
  showSubHeader: PropTypes.bool,
};

Flex.defaultProps = {
  headerTitle: process.env.REACT_APP_NAME,
  height: undefined,
  showSubHeader: undefined,
};
